module.exports = __webpack_public_path__ + "media/images/coffee-7929f1d608ed5e9ca4b8f4a2164acc92.svg";